import React from 'react'
import styled from 'styled-components'
import Card from './Card'

const StyledGrid = styled.div`
  align-items: flex-end;
  display: flex;
  flex-wrap: wrap;
  grid-column-gap: 24px;
  grid-row-gap: 24px;
  grid-template-columns: repeat(12, 1fr);
  grid-template-rows: 480px 480px;
  justify-content: space-between;
  margin-top: 88px;
  padding: 24px 24px;
  ${({ theme }) => theme.media.desktop} {
    display: grid;
    padding: 0;
  }
`

const MasonryCards = ({ data, images }) => {
  return (
    <StyledGrid>
      {images && (
        <>
          {/* Thats hardcoded for Company Page in which we don't want them to mess with this */}
          <Card
            mobileDisabled={false}
            key={1}
            cardData={{
              type: 'image',
              start: 1,
              width: 7,
              offset: false,
              position: 'end',
              img: images.image1.fluid,
            }}
          />
          <Card
            mobileDisabled={false}
            key={2}
            cardData={{
              type: 'image',
              start: 8,
              width: 5,
              offset: false,
              position: 'end',
              img: images.image2.fluid,
            }}
          />
          <Card
            mobileDisabled={false}
            key={3}
            cardData={{
              type: 'data',
              start: 2,
              width: 5,
              offset: false,
              position: 'start',
              text: images.cardTitle,
              button: {
                text: images.cardButton.buttonText,
                link: images.cardButton.buttonLink,
              },
            }}
          />
          <Card
            mobileDisabled={false}
            key={4}
            cardData={{
              type: 'image',
              start: 7,
              width: 4,
              offset: false,
              position: 'start',
              img: images.image3.fluid,
            }}
          />
        </>
      )}
      {data &&
        data.map((card, index) => (
          <Card
            mobileDisabled={
              card.type === 'image' && index === data.length - 1 ? true : false
            }
            key={card.id}
            cardData={card}
          />
        ))}
    </StyledGrid>
  )
}

export default MasonryCards
